export function decodedLinks() {
    const decodeAndNavigate = (e) => {
        const encodedHref = e.currentTarget.getAttribute('data-b64e-lnk');
        const target = e.currentTarget.getAttribute('target');

        if (encodedHref && (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13)) {
            e.preventDefault();
            // Verschachtelte b64e-lnk (z. B. Größen-Box in der Artikelkachel): Klick nicht an
            // ein umschließendes b64e-lnk-Element weiterreichen, damit der spezifische Link
            // (Größe) und nicht der Eltern-Link (angezeigte Farbe) geöffnet wird.
            e.stopPropagation();
            try {
                const decodedHref = atob(decodeURIComponent(encodedHref));
                if (e.ctrlKey || e.metaKey || target === '_blank') {
                    const newWindow = window.open(decodedHref, '_blank', 'noopener');
                    if (newWindow) {
                        newWindow.opener = null;
                        newWindow.focus();
                    }
                } else {
                    document.location.href = decodedHref;
                }
            } catch (error) {
                console.log("Fehler beim Decodieren des Links:", error);
            }
        }
    };

    document.querySelectorAll('.b64e-lnk').forEach(element => {
        element.setAttribute('tabindex', '0');
        element.setAttribute('role', 'link');
        element.addEventListener('click', decodeAndNavigate);
        element.addEventListener('keypress', decodeAndNavigate);
    });
}